import { render, staticRenderFns } from "./EditBusinessInformationPage.vue?vue&type=template&id=44dc3ca1"
import script from "./EditBusinessInformationPage.vue?vue&type=script&lang=js"
export * from "./EditBusinessInformationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports